import React from "react";
import { useTranslation } from "react-i18next";
import ProfileBioEditModal from "../ProfileBioEditModal";

export default function ProfileProgressionDetails({ progressionView }) {
  const { t } = useTranslation();
  const {
    activeInfoModal,
    activeModalCopy,
    showPrivateDetails,
    normalizedProfileDetails,
    bioTextRef,
    isBioExpanded,
    doesBioOverflow,
    isBioEditorOpen,
    closeInfoModal,
    handleOpenBioEditor,
    handleCloseBioEditor,
    handleBioDetailsSaved,
    handleUsernameSaved,
    toggleBioExpanded,
  } = progressionView;

  return (
    <>
      {activeModalCopy ? (
        <div
          className="profile-progression-modal-overlay"
          onClick={closeInfoModal}
        >
          <div
            className={`profile-progression-modal ${
              activeInfoModal === "bio" ? "profile-progression-modal--bio" : ""
            }`.trim()}
            role="dialog"
            aria-modal="true"
            aria-label={activeModalCopy.dialogLabel}
            onClick={(event) => event.stopPropagation()}
          >
            <div className="profile-progression-modal-header-actions">
              {activeInfoModal === "bio" && showPrivateDetails ? (
                <button
                  type="button"
                  className="profile-progression-modal-action-button profile-progression-modal-action-button--secondary"
                  onClick={handleOpenBioEditor}
                >
                  {t("profile_bio_edit_button", {
                    defaultValue: "Update Bio",
                  })}
                </button>
              ) : null}

              <button
                type="button"
                className="profile-progression-modal-close"
                onClick={closeInfoModal}
              >
                {t("progression_milestone_popup_close", {
                  defaultValue: "Close",
                })}
              </button>
            </div>

            <div
              className={`profile-progression-modal-kicker ${
                activeInfoModal === "bio"
                  ? "profile-progression-modal-kicker--bio"
                  : ""
              }`.trim()}
            >
              {activeModalCopy.kicker}
            </div>

            {activeModalCopy.title ? (
              <h3 className="profile-progression-modal-title">
                {activeModalCopy.title}
              </h3>
            ) : null}

            {activeModalCopy.badgeImage ? (
              <img
                src={activeModalCopy.badgeImage}
                alt={activeModalCopy.badgeAlt || ""}
                className="profile-progression-modal-badge-image"
              />
            ) : null}

            {activeModalCopy.body ? (
              <p className="profile-progression-modal-body">
                {activeModalCopy.body}
              </p>
            ) : null}

            {activeModalCopy.bullets?.length ? (
              <ul className="profile-progression-modal-list">
                {activeModalCopy.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            ) : null}

            {activeModalCopy.rows ? (
              activeModalCopy.bioRow || activeModalCopy.rows.length ? (
                <div
                  className={`profile-progression-modal-details ${
                    activeInfoModal === "bio"
                      ? "profile-progression-modal-details--bio"
                      : ""
                  }`.trim()}
                >
                  {activeModalCopy.bioRow ? (
                    <div className="profile-progression-modal-detail profile-progression-modal-detail--bio-primary">
                      <span className="profile-progression-modal-detail-label">
                        {activeModalCopy.bioRow.label}
                      </span>
                      <p
                        ref={bioTextRef}
                        className={`profile-progression-modal-detail-value ${
                          !isBioExpanded && doesBioOverflow
                            ? "profile-progression-modal-detail-value--clamped"
                            : ""
                        }`.trim()}
                      >
                        {activeModalCopy.bioRow.value}
                      </p>
                      {doesBioOverflow ? (
                        <button
                          type="button"
                          className="profile-progression-modal-bio-toggle"
                          onClick={toggleBioExpanded}
                        >
                          {isBioExpanded
                            ? t("profile_bio_show_less", {
                                defaultValue: "Show less",
                              })
                            : t("profile_bio_read_more", {
                                defaultValue: "Read more",
                              })}
                        </button>
                      ) : null}
                    </div>
                  ) : null}

                  {activeModalCopy.rows.length ? (
                    <div
                      className={`${
                        activeInfoModal === "bio"
                          ? "profile-progression-modal-details-grid"
                          : ""
                      }`.trim()}
                    >
                      {activeModalCopy.rows.map((row) => (
                        <div
                          key={row.label}
                          className="profile-progression-modal-detail"
                        >
                          <span className="profile-progression-modal-detail-label">
                            {row.label}
                          </span>
                          <p className="profile-progression-modal-detail-value">
                            {row.value}
                          </p>
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              ) : (
                <p className="profile-progression-modal-empty">
                  {activeModalCopy.emptyMessage}
                </p>
              )
            ) : null}

            {activeModalCopy.pill ? (
              <div className="profile-progression-modal-pill">
                {activeModalCopy.pill}
              </div>
            ) : null}
          </div>
        </div>
      ) : null}

      {isBioEditorOpen && showPrivateDetails && normalizedProfileDetails ? (
        <ProfileBioEditModal
          profileDetails={normalizedProfileDetails}
          onClose={handleCloseBioEditor}
          onSaved={handleBioDetailsSaved}
          onUsernameSaved={handleUsernameSaved}
        />
      ) : null}
    </>
  );
}
